import { render, staticRenderFns } from "./AttachmentDashboard.vue?vue&type=template&id=e20cdd62"
import script from "./AttachmentDashboard.vue?vue&type=script&lang=js"
export * from "./AttachmentDashboard.vue?vue&type=script&lang=js"
import style0 from "./AttachmentDashboard.vue?vue&type=style&index=0&id=e20cdd62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports